import React from 'react';
import { Box, Flex, Text } from '@spothero/ui';
export const RatingDistributionBar = ({ label, percentage, }) => {
    return (<Flex alignItems="center" gap={2} marginBottom={1} data-testid="RatingDistributionBar">
            <Text fontSize="xs" fontWeight="medium" width={4} textAlign="right">
                {label}
            </Text>
            <Box flexGrow={1} height={2} bg="gray.100" borderRadius="full" overflow="hidden">
                <Box height="100%" width={`${percentage}%`} bg="gray.dark" borderRadius="full"/>
            </Box>
            <Text fontSize="xs" fontWeight="medium" width={8}>
                {percentage}%
            </Text>
        </Flex>);
};
